<template>
  <van-form @submit="onSubmit">
    <h3 class="card-edit-section-title section-title">
      {{ $t("front of the card") }} 🇩🇪
    </h3>
    <van-field
      clickable
      name="front_word"
      v-model="frontWord"
      :label="$t('word')"
      :placeholder="$t('input word')"
      :error-message="formError('front_word.word')"
    />
    <!-- <van-field
      readonly
      clickable
      name="picker"
      :value="wordTypeFormatted"
      :label="$t('word type')"
      :placeholder="$t('select word type')"
      :error-message="formError('front_word.word_type')"
      @click="showPicker = true"
    /> -->
    <div class="wordtype-section">
      <div class="ws-heading">
        {{ $t("word type") }}
      </div>
      <div class="wordtype-tags-wrapper">
        <template v-for="w in wordTypes">
          <span
            class="wordtype-tags"
            :class="{ active: w.name == wordType[0] }"
            :key="`${w.name}-${w.id}`"
            @click="setWordType(w.name, w.id)"
            >{{ w.name }}</span
          >
        </template>
      </div>
      <div>
        {{ formError("front_word.word_type") }}
      </div>
    </div>
    <div class="wordtype-section" v-if="wordType[0] == 'Nomen'">
      <div class="ws-heading">
        {{ $t("Artikel") }}
      </div>
      <div class="wordtype-tags-wrapper">
        <span
          @click="setArticleType(a)"
          :class="{ active: a == wordType[1] }"
          class="wordtype-tags"
          v-for="a in artikel"
          :key="a"
        >
          {{ a }}
        </span>
      </div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
        :confirm-button-text="$t('confirm')"
        :cancel-button-text="$t('cancel')"
      />
    </van-popup>
    <van-field
      v-model="frontSentence"
      type="textarea"
      name="front_sentence"
      :label="$t('sentence')"
      :placeholder="$t('sentence')"
      :error-message="formError('front_sentence.sentence')"
      :rules="[{ required: false, message: $t('sentence is required') }]"
      :autosize="{ maxHeight: 120, minHeight: 90 }"
    />
    <van-field name="uploader" :label="$t('image')">
      <template #input>
        <van-uploader v-model="uploader" :multiple="false" :max-count="1" />
      </template>
    </van-field>
    <h3 class="card-edit-section-title section-title">
      {{ $t("back of the card") }} 🇺🇸
    </h3>
    <van-field
      clickable
      name="back_word"
      v-model="backWord"
      :label="$t('word')"
      :placeholder="$t('input word')"
      :error-message="formError('back_word.word')"
    />
    <van-field
      v-model="backSentence"
      type="textarea"
      name="back_sentence"
      :label="$t('sentence')"
      :placeholder="$t('sentence')"
      :error-message="formError('back_sentence.sentence')"
      :rules="[{ required: false, message: $t('sentence is required') }]"
      :autosize="{ maxHeight: 120, minHeight: 90 }"
    />
    <div style="margin: 16px; display:flex">
      <van-button round block type="info" native-type="save">
        {{ $t("submit") }}
      </van-button>
    </div>
  </van-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "CardForm",
  props: {
    box: {
      type: Number,
      required: true
    },
    currentCard: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      showPicker: false,
      artikel: {
        m: "der",
        f: "die",
        n: "das"
      },
      artikelLetter: {
        der: "m",
        die: "f",
        das: "n"
      },
      uploader: [],
      frontWord: "",
      word_type: null,
      wordType: ["", ""],
      wordTypeIndexes: null,
      frontSentence: "",
      backWord: "",
      backSentence: "",
      validationErrors: {}
    };
  },
  computed: {
    ...mapState("vokabel", ["wordTypes"]),
    columns() {
      let artikels = Object.values(this.artikel);
      return this.wordTypes.map(item => {
        if (item.name.toLowerCase() == "nomen") {
          return { text: item.name, children: artikels };
        }
        return { text: item.name, children: [] };
      });
    },
    wordTypeFormatted() {
      const { wordType } = this;
      if (wordType[1]) {
        return `${wordType[0]} ${wordType[1]}`;
      }
      return wordType[0];
    }
  },
  watch: {
    currentCard() {
      this.boundForm();
    },
    wordTypes() {
      this.boundForm();
    }
  },
  methods: {
    ...mapActions("vokabel", ["getWordTypes", "AddWordToBox"]),
    boundForm() {
      this.wordType = ["", ""];
      this.wordTypeIndexes = null;

      if (this.currentCard) {
        const {
          front_word,
          back_word,
          front_sentence,
          back_sentence,
          image
        } = this.currentCard;
        this.frontWord = front_word && front_word.word ? front_word.word : "";
        this.backWord = back_word && back_word.word ? back_word.word : "";
        if (front_word) {
          // vant picker handles the picker with an array
          for (let i = 0; i < this.wordTypes.length; i++) {
            if (front_word.word_type == this.wordTypes[i].id) {
              this.wordType = [];
              this.wordType.push(this.wordTypes[i].name);
              this.word_type = this.wordTypes[i].id;
              this.wordTypeIndexes = [i];
              if (front_word.details && front_word.details.artikel) {
                this.wordType.push(this.artikel[front_word.details.artikel]);
                for (let j = 0; j < Object.keys(this.artikel).length; j++) {
                  if (
                    Object.keys(this.artikel)[j] == front_word.details.artikel
                  ) {
                    this.wordTypeIndexes[1] = j;
                    break;
                  }
                }
              } else {
                this.wordType[1] = null;
                this.wordTypeIndexes[1] = null;
              }
              break;
            }
          }
        }
        this.frontSentence =
          front_sentence && front_sentence.sentence
            ? front_sentence.sentence
            : "";
        this.backSentence =
          back_sentence && back_sentence.sentence ? back_sentence.sentence : "";
        if (image) {
          this.uploader = [
            {
              url: `https://f002.backblazeb2.com/file/${image}`
            }
          ];
        }
      } else {
        this.frontWord = "";
        this.frontSentence = "";
        this.backWord = "";
        this.backSentence = "";
      }
    },
    setWordType(v, id) {
      this.word_type = id;
      this.$set(this, "wordType", [v, ""]);
    },
    setArticleType(v) {
      let wt = this.wordType[0];
      this.$set(this, "wordType", [wt, v]);
    },
    onConfirm(value, indexes) {
      this.wordType = value;
      this.wordTypeIndexes = indexes;
      this.showPicker = false;
    },
    onSubmit() {
      const {
        box,
        currentCard,
        frontWord,
        // wordTypeIndexes,
        wordType,
        // wordTypes,
        frontSentence,
        backWord,
        backSentence,
        artikelLetter
      } = this;
      let card = currentCard && currentCard.id ? currentCard.id : null;
      var word_type = this.word_type;
      let details = {};
      if (wordType[1]) {
        details = { artikel: artikelLetter[wordType[1]] };
      }

      // if (wordTypes && wordTypeIndexes && wordTypeIndexes.length > 0) {
      //   if (wordTypeIndexes[0] <= wordTypes.length) {
      //     word_type = wordTypes[wordTypeIndexes[0]].id;
      //   }
      //   // and artikel(s) if any
      //   let artikels = Object.values(this.artikel);
      //   // fix for multi article in future
      //   if (wordType[1]) {
      //     details = { artikel: artikelLetter[artikels[wordTypeIndexes[1]]] };
      //   }
      //   // for (let i = 1; i < wordType.length; i++) {
      //   //   if (details == null) {
      //   //     details = { artikel: artikelLetter[artikels[wordTypeIndexes[i]]] };
      //   //   } else {
      //   //     details["artikel"] +=
      //   //       ", " + artikelLetter[artikels[wordTypeIndexes[i]]];
      //   //   }
      //   // }
      // }

      let postData = {
        card,
        front_word: {
          word: frontWord,
          details,
          language: 1, //hard code DE for now
          word_type: word_type,
          sentence: frontSentence
        },
        back_word: {
          word: backWord,
          language: 2, //hard code EN for now
          word_type: word_type,
          sentence: backSentence
        }
      };
      let formData = new FormData();
      formData.append("formData", JSON.stringify(postData));
      if (this.uploader.length > 0) {
        formData.append("image", this.uploader[0].file);
      }

      this.AddWordToBox({ id: box, formData })
        .then(() => {
          this.$emit("cardFormSubmitted");
        })
        .catch(({ response: { data } }) => {
          this.validationErrors = data;
        });
    },
    formError(field) {
      if (field in this.validationErrors) {
        return this.validationErrors[field].join();
      }
      return null;
    }
  },
  mounted() {
    this.getWordTypes();
    this.boundForm();
  }
};
</script>

<style>
.ws-heading {
  font-size: 14px;
}
.wordtype-section {
  padding: 16px;
}
.wordtype-tags-wrapper {
  display: flex;
  flex-wrap: wrap;
}
.wordtype-tags {
  margin: 5px;
  padding: 5px 8px;
  border-radius: 3px;
  border: 1px solid rgb(17 185 129);
  cursor: pointer;
  /* background:  */
  color: rgb(17 185 129);
}
.wordtype-tags.active {
  background: rgb(17 185 129);
  color: rgb(209 250 228);
}
</style>
